import axios from 'services/axios'
import {
  API_PAYMENT_CONTRACT_INFO,
  API_PAYMENT_CONTRACT_SUMMARY,
} from 'constants/endpoints'

// Models
import Contract from 'models/Contract'

/**
 * Get contract info
 *
 * @param {Object} { contractNumber, vendorCode, companyCode, notificationId }
 * @return {Object}
 */
export const getContractInfo = async ({
  contractNumber,
  vendorCode,
  companyCode,
  notificationId = null,
}) => {
  try {
    const { data, status, ...rest } = await axios.post(
      API_PAYMENT_CONTRACT_INFO,
      {
        contractNumber,
        vendorCode,
        companyCode,
        notifiId: notificationId,
      }
    )

    if (status === 200) {
      return new Contract(data)
    }

    throw rest
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get contract details
 *
 * @param {Object} { contractNumber, vendorCode, companyCode }
 * @return {Object}
 */
export const getContractSummary = async ({
  contractNumber,
  vendorCode,
  companyCode,
}) => {
  try {
    const { data } = await axios.post(API_PAYMENT_CONTRACT_SUMMARY, {
      contractNumber,
      vendorCode,
      companyCode,
    })

    return {
      total: data.totalPayemnts,
      paid: data.paidPayments,
      pending: data.pendingPayments,
    }
  } catch (error) {
    return Promise.reject(error)
  }
}
